import React, { type ReactNode } from "react";

interface InfoCardProps {
  title: string;
  description?: ReactNode;
  children?: ReactNode;
}

export function InfoCard({ title, description, children }: InfoCardProps) {
  return (
    <div className="mx-auto mt-24 max-w-md px-6">
      <div className="border-2 border-ink p-8">
        <h1 className="font-mono text-sm font-bold uppercase tracking-[0.2em] text-ink">
          {title}
        </h1>
        {description ? (
          <p className="mt-4 text-sm leading-relaxed text-ink">{description}</p>
        ) : null}
        {children ? <div className="mt-6">{children}</div> : null}
      </div>
    </div>
  );
}
